<template>
  <div class="material-Input-View">
    <PageTitle imagem="bottles.png" main="Plano de Consumo de Insumos" sub="" />
    <MaterialInputViewTable />
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import MaterialInputViewTable from "./materialInputViewTable";

export default {
  name: "materialInputView",
  components: { PageTitle, MaterialInputViewTable },
  beforeDestroy() {

  }
};
</script>

<style></style>